import header from './header';
import menu from './menu';

export default {
    COMMON_TITLE_LOADING: '加载中...',
    ...header,
    ...menu
};
